import { defineMessages } from 'react-intl';

export default defineMessages({
  baseTitle: {
    id: 'gift.pageHelmet.baseTitle',
    defaultMessage: 'Starbucks Gift Cards',
    description: 'Document title for gift page',
  },
  categoryTitle: {
    id: 'gift.pageHelmet.categoryTitle',
    defaultMessage: 'Starbucks {categoryName} Gift Cards',
    description: 'Document title for gift category page',
  },
  cardDetailTitle: {
    id: 'gift.pageHelmet.cardDetailTitle',
    defaultMessage: 'Starbucks Gift Card: {cardName}',
    description: 'Document title for gift card detail page',
  },
  description: {
    id: 'gift.pageHelmet.metaDescription',
    defaultMessage:
      "There's a Starbucks Card for everyone. Order online today.",
    description: 'Meta description for gift page',
  },
});
